import React, { Fragment} from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import Price from "components/Price/Price"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import ProductRowCartAction from "components/Product/ProductRowCartAction"
import ListActions from "theme/hvz/components/Product/ProductRowListAction"
import { Label } from "semantic-ui-react";
import shop from "shop/shop"
import OrderModel   from "shop/OrderModel";
import Responsive                                                from "react-responsive"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0
let articleOpen = 0		
//console.log("PRODUCTS ROW: ", shop.cart.products)
const ProductRowDefault = observer( ( { product, onChange, list, cart } ) => {
  let pageSize = 20
  let start = current
  current = current + pageSize
  /*shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
    .then( res => {
      console.log( "FROM API", { res } )
      orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
      openPositions = []
      // find orders with Open Positions
      let orderOpen = orders.filter( order => {
      return order.positions.filter( product => {
        let hasOpen = product.open && product.open !== 0
        if ( hasOpen ) {
        openPositions.push( product )
        console.log("PRODUCT: ",product)
        console.log("OPENPOSITIONS: ",openPositions)
        if(openPositions){
          if(openPositions.length > 0){
            for(let i = 0; openPositions.length > i;i++){
              if(openPositions[i].article_nr == product.article_nr){
                articleOpen = 1
              }
            }
          }
          
        }
        }
        return hasOpen
      } ).length
      } )
      
    } )
    console.log("HASOPEN:", openPositions)
    console.log("HASOPEN:", product.article_nr)
    let articleOpen = 0		
		if(openPositions){
			if(openPositions.length > 0){
				console.log("HASOPEN:", openPositions[0].article_nr)
				console.log("HASOPEN:", product.article_nr)
				for(let i = 0; openPositions.length > i;i++){
					if(openPositions[i].article_nr == product.article_nr){
						console.log("hasopenpassig")
						articleOpen = 1
					}
				}
			}
			
		}*/
    //console.log("pro ",product)

  if (shop.cart && shop.cart.data && Array.isArray(shop.cart.data.products) && shop.cart.data.extras && shop.cart.data.extras.couponCode !== "" ) {
    const cartProduct = shop.cart.data.products.find(p => p.article_id === product.map_id);
    console.log("cartProduct",cartProduct, shop.cart.data, product)
    if (cartProduct) {
      product.price = cartProduct.price;
      if (cartProduct.extras && cartProduct.extras.brutto !== undefined) {
        if (!product.pinfos) product.pinfos = {};
        product.pinfos.brutto = cartProduct.extras.brutto;
      }
    }
  }
  //console.log("product in row:", shop.cart.contains(product))
  const hasCustomVE = product.extras.Z_Verpackungseinheit_Anzahl && product.extras.Z_Verpackungseinheit_Anzahl !== "1"
  const priceInquiryOnly = !!(product.extras && product.extras.Preisanfrage && product.extras.Preisanfrage.value && product.extras.Preisanfrage.value.value === "J")
  //console.log("shop.cart.products PRE",shop.cart.data)
  if(Object.keys(product.pinfos).length !== 0){
    if(product.pinfos.brutto){
      //shop.cart.setExtraPositions(product, "couponPrice", (product.pinfos.brutto));
    }
  }
  //console.log("shop.cart.products POST",shop.cart.data)
  return (
    <Fragment>
    <Responsive minWidth={900}>
    <tr>
      <td>
        {cart ? <ProductRowCartAction cart={cart} product={product}/> : null}
      </td>
      <td>
				<Link to={`/product/${product.map_id}`}>
					<img
						className="db center"
            style={{maxWidth: "35px",maxHeight: "35px", minWidth: "35px",minHeight: "35px", overflow: "hidden",objectFit: "contain"}}
						src={product.img_src_small}
						alt=""/>
				</Link>
			</td>
      <td>
        <Link to={`/product/${product.map_id}`}>
          <strong>{product.article_nr}</strong> <br/>
          <span className="product-title">{product.title}</span>
        </Link>
      </td>
      <td><span className="f6 tc">{product.getNotice( "tiny" )}</span></td>
      {console.log("product infos:", product, shop.cart)}
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <td>
      {!priceInquiryOnly && product.pinfos && product.pinfos.brutto && product.pinfos.brutto != "" && <div className="tr pr2">
        <span className="strike black-60"><Price>{product.pinfos.brutto}</Price></span><br/><span className="red fw6 pb2 tc"><Price>{product.price}</Price></span></div>}
      {!priceInquiryOnly && product.pinfos && (!product.pinfos.brutto || product.pinfos.brutto === "") && <div className="tr pr2"><Price>{product.price}</Price></div>}
      {!priceInquiryOnly && Object.keys(product.pinfos).length === 0 &&  <div className="tr pr2"><Price>{product.price}</Price></div>}
        <div className="flex flex-row">
          {/*product.pinfos.gc_rabatt && <div title={translate( "Coupon-Rabatt" )} className="mr1 pb2"><Label size="tiny" className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div>*/}
          {/*product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
          {/*product.isSale && <div title={translate( "Ihr Kundenrabatt" )} className="pb2"><Label size="tiny" className={"salePercent"} color="red">-{product.salePercent}</Label></div>*/}
          {/*product.isSale && <a className="labelNeu">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>*/}
          {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
          {articleOpen == 1 && <a className="labelNeu">&nbsp;&nbsp;{translate("Rückstand")}&nbsp;&nbsp;</a>}
        </div>
        <div className="">
                                                 {!priceInquiryOnly && shop.session && shop.session.shopuser && !shop.session.shopuser.guest && product.prices && product.prices.length >= 1 && product.prices.map( price => (
                                                    <div className="tr" key={price.q}>
                                                      <td colSpan={2} className="f7 fr" style={{paddingTop: "0px", paddingBottom: "0px"}} >{translate("ab")} {price.q} &nbsp; {price.p.toFixed(2).replace(".",",")} €</td>
                                                    </div>
                                                  ) )}
        </div>
      </td>}

      <td>
        <div>{product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")} </div>
        <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
      </td>
      <td>
        <div>{product.extras && product.extras["086"] ? product.extras["086"].value.value : "-"} </div>
        <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
      </td>
      {/*<td><Price>{product.price * product.unit_multi}</Price></td>*/}
      {/*<td></td>*/}
                  {/*list && <td>
          {product.count}
        </td>*/}
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <td>
        <div className="tr">
        {!priceInquiryOnly && product.pinfos && product.pinfos.brutto && product.pinfos.brutto != "" && <div><span className="strike black-60"><Price>{product.pinfos.brutto * product.count * product.unit_multi}</Price></span><br/><span className="red fw6 pb2 tc"><Price>{product.price * product.count * product.unit_multi}</Price></span></div>}
        {!priceInquiryOnly && product.pinfos && (!product.pinfos.brutto || product.pinfos.brutto === "") && <div className="tr pr2"><Price>{product.price * product.count * product.unit_multi}</Price></div>}
        {!priceInquiryOnly && Object.keys(product.pinfos).length === 0 && <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
          {!priceInquiryOnly && <div>{product.unit_multi * product.count} {product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")}</div>}
        </div>
      </td>}

      <td className="tr">
        {!priceInquiryOnly && <ProductCount list={list ? true : false} product={product} onChange={onChange} disabled={priceInquiryOnly}/>}
      </td>
      
      {list &&  <td>
        <div className="fr"><ListActions list={list} product={product}/></div>
      </td>}
    </tr>
    </Responsive>
    <Responsive maxWidth={899}>
    <tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
    <td className="tl pt2 pb2">
				<Link to={`/product/${product.map_id}`}>
					<img style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
						className="pl2 db left"
						src={product.img_src_small}
						alt=""/>
				</Link>
			</td>
        <td  className=" pr2  pt2 bb b--black-20 tr f6 v-center">
                  <Link to={`/product/${product.map_id}`}>
          <strong>{product.article_nr}</strong> &nbsp;
          <span className="product-title">{product.title}</span>
        </Link></td>
        <td>&nbsp;</td>
      </tr>
      <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Lieferbar:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7"><span className="f6 tr">{product.getNotice( "tiny" )}</span></td>
      </tr>
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Preis/VE:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
      {!priceInquiryOnly && product.pinfos && product.pinfos.brutto && product.pinfos.brutto !== "" && <div className="tr pr2"><span className="strike black-60"><Price>{product.pinfos.brutto}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{product.price}</Price></span></div>}
      {!priceInquiryOnly && product.pinfos && (!product.pinfos.brutto || product.pinfos.brutto === "") && <div className="tr pr2"><Price>{product.price}</Price></div>}
      {!priceInquiryOnly && Object.keys(product.pinfos).length === 0 &&  <div className="tr pr2"><Price>{product.price}</Price></div>}
        <div className="flex flex-row">
          {/*product.pinfos.gc_rabatt && <div title={translate( "Coupon-Rabatt" )} className="mr1 pb2"><Label size="tiny" className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div>*/}
          {/*product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
          {/*product.isSale && <div title={translate( "Ihr Kundenrabatt" )} className="pb2"><Label size="tiny" className={"salePercent"} color="red">-{product.salePercent}</Label></div>*/}
          {/*product.isSale && <a className="labelNeu">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>*/}
          {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
          {articleOpen == 1 && <a className="labelNeu">&nbsp;&nbsp;{translate("Rückstand")}&nbsp;&nbsp;</a>}
        </div>
                <div className="">
                                                 {!priceInquiryOnly && shop.session && shop.session.shopuser && !shop.session.shopuser.guest && product.prices && product.prices.length >= 1 && product.prices.map( price => (
                                                    <div className="tr pr2" key={price.q}>
                                                      <td colSpan={2} className="f7 fr" style={{paddingTop: "0px", paddingBottom: "0px"}} >{translate("ab")} {price.q} &nbsp; {price.p.toFixed(2).replace(".",",")} €</td><br/>
                                                    </div>
                                                  ) )}
        </div>
        </td>
      </tr>}
      <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "VE:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
        <div>{product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")} </div>
        <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
        </td>
      </tr>
      <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Kartoninhalt:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
        <div>{product.extras && product.extras["086"] ? product.extras["086"].value.value : "-"} </div>
        <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
        </td>
      </tr>
      {/*list && <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Menge:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
        <div>{product.count} </div>
        </td>
      </tr>*/}
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Summe:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
        <div className="tr">
        {!priceInquiryOnly && product.pinfos && product.pinfos.brutto && product.pinfos.brutto !== "" && <div><span className="strike black-60"><Price>{product.pinfos.brutto * product.count * product.unit_multi}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{product.price * product.count * product.unit_multi}</Price></span></div>}
        {!priceInquiryOnly && product.pinfos && (!product.pinfos.brutto || product.pinfos.brutto === "") && <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
        {!priceInquiryOnly && Object.keys(product.pinfos).length === 0 && <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
          {!priceInquiryOnly && <div>{product.unit_multi * product.count} {product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")}</div>}
        </div>
        </td>
      </tr>}
      <tr className={` ProductRowDefReturnMobileRight step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Quantity(PU):" )} </td>
        <td  className="pr2 bb b--black-20 tr f5">{!priceInquiryOnly &&<Fragment><ProductCount list={list ? true : false} product={product} onChange={onChange} disabled={priceInquiryOnly}/></Fragment>}{list && <ListActions list={list} product={product}/>}</td>
      </tr>

      {/*<tr className={`  ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="bb fw7 f5 ProductRowDefReturnMobileLeft">
        {translate( "UVP:" )}
        </td >
      <td className="tr b--black-20 bb ProductRowDefReturnMobileRight">
        <Price>{product.price * (product.count-1)}</Price>
        </td>
      </tr>*/}
    </Responsive>
    </Fragment>
  )
} )
export default ProductRowDefault

ProductRowDefault.propTypes = {
  index   : PropTypes.any,
  list    : PropTypes.object,
  cart    : PropTypes.object,
  onChange: PropTypes.func,
  product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductRowDefault.js